import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSearchStore } from '../store/search/searchStore';

const PrivateRoute = () => {
    const location = useLocation();
    const checkAuth = () => 
        !!localStorage.getItem('token') && !!localStorage.getItem('apiSessionStorage');
    
    const [isAuthenticated, setIsAuthenticated] = useState(checkAuth());

    const account_status= localStorage.getItem('account');
    const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
    useSearchStore();
    useEffect(() => {
        resetSearch();
        // Check auth status on mount and route changes
        setIsAuthenticated(checkAuth() && account_status =='1');

        const handleAuthChange = () => {
            setIsAuthenticated(checkAuth() && account_status =='1');
        };

        window.addEventListener('authChange', handleAuthChange);
        window.addEventListener('storage', handleAuthChange);
        
        return () => {
            window.removeEventListener('authChange', handleAuthChange);
            window.removeEventListener('storage', handleAuthChange);
        };
    }, [location]);
    
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;